const name = {
  field: 'name',
  headerName: 'Name',
  width: 300,
  type: 'customSelect',
};
const shortName = {
  field: 'shortName',
  headerName: 'Short Name',
  width: 200,
  type: 'customSelect',
};

// address: null;
const address = {
  field: 'address',
  headerName: 'Address',
  width: 200,
  type: 'customSelect',
};
const city = {
  field: 'city',
  headerName: 'City',
  width: 200,
  type: 'customSelect',
};
const state = {
  field: 'state',
  headerName: 'State',
  width: 200,
  type: 'customSelect',
};
const zip = {
  field: 'zip',
  headerName: 'Zip',
  width: 200,
  type: 'customSelect',
};

const GROUPS = [name, shortName, address, city, state, zip];

export { GROUPS };
